// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__35BU7","gfeWrapper":"CalendarEvent_gfeWrapper__1SLIl"};